// src/config.js
const isProd =
  (typeof import.meta !== "undefined" && import.meta.env && import.meta.env.PROD) ||
  (typeof process !== "undefined" && process.env && process.env.NODE_ENV === "production");

function normalizeBase(v) {
  return String(v || "").trim().replace(/\/+$/, "");
}

const RUNTIME_API_BASE =
  typeof window !== "undefined" && window.__API_BASE__ ? String(window.__API_BASE__) : "";

const ENV_API_BASE =
  (typeof import.meta !== "undefined" && import.meta.env && import.meta.env.VITE_API_BASE) ||
  (typeof process !== "undefined" && process.env && process.env.REACT_APP_API_BASE) ||
  "";

const rawBase =
  normalizeBase(RUNTIME_API_BASE) ||
  normalizeBase(ENV_API_BASE) ||
  (isProd ? "https://api.soscontrol.it" : "http://localhost:3001");

// ✅ qui NON mettere /api
export const API_BASE = normalizeBase(rawBase);

export const AUTH_BASE = normalizeBase(
  (typeof import.meta !== "undefined" && import.meta.env && import.meta.env.VITE_AUTH_BASE) ||
    (typeof process !== "undefined" && process.env && process.env.REACT_APP_AUTH_BASE) ||
    "https://auth.soscontrol.it"
);
